import slug from 'slug';
import normalizeText from 'normalize-text';
const charactersForSubstitution = {
    // URI reserved characters, see RFC 3986
    '!': '-',
    '"': '-',
    '#': '-',
    '$': '-',
    '%': '-',
    '\'': '-',
    '(': '-',
    ')': '-',
    '*': '-',
    ',': '-',
    '/': '-',
    ':': '-',
    ';': '-',
    '=': '-',
    '?': '-',
    '@': '-',
    '[': '-',
    ']': '-',
    // URI unreserved characters, see RFC 3986
    '_': '-',
    '.': '-',
    '~': '-',
    // Special handed characters
    '&': '-a-',
    '+': '-plus-',
    'ᵉ': '-e-',
};
export function removeDiacritics(value) {
    for (const character in charactersForSubstitution) {
        // NOTE: string.replace() replaces only the first occurrences .
        value = value.split(character).join(charactersForSubstitution[character]);
    }
    // NOTE normalizeText() makes (see https://www.npmjs.com/package/normalize-text)
    // - lower cases
    // - remove diacritics
    // - replace each whitespace group by a space
    //
    // NOTE slug() makes (see https://www.npmjs.com/package/slug)
    // - respect RFC 3986
    // - use '-' as replacement
    // - trim leading and trailing '-'
    // - replace each '-' group by one '-'
    return slug(normalizeText(value));
}
